import React from "react";
import { openWhatsapp } from "@/lib/cima";

export default function WhatsAppFloat() {
  return (
    <button
      type="button"
      data-testid="whatsapp-float-button"
      onClick={() =>
        openWhatsapp(
          "Hola CIMA, vengo desde su sitio web y me gustaría solicitar una cotización."
        )
      }
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-5 right-5 z-50 wa-pulse flex items-center justify-center w-14 h-14 lg:w-16 lg:h-16 bg-[#16A34A] hover:bg-[#15803D] text-white rounded-full shadow-2xl transition-colors"
    >
      <svg viewBox="0 0 24 24" className="w-7 h-7 lg:w-8 lg:h-8 fill-current">
        <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 018.413 3.488 11.82 11.82 0 013.48 8.414c-.003 6.554-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.689-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.762 5.617L1.95 21.255l3.704-1.062zM17.42 14.5c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.151-.174.2-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.371-.272.298-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/>
      </svg>
    </button>
  );
}
